import {
	KSK1120_R01DetailDto,
	KSK1120_R01ValueType,
	KSK1120_R01_VALUE_FIELDS,
} from "./Dto_KSK1120_R01";

export const normalizeKSK1120_R01ValueType = (
	valueType: KSK1120_R01DetailDto["valueType"],
): KSK1120_R01ValueType | "" => {
	const normalizedValueType = String(valueType ?? "").trim().toUpperCase();
	return normalizedValueType === "NUMERIC"
		|| normalizedValueType === "TEXT"
		|| normalizedValueType === "PASS_FAIL"
		? normalizedValueType
		: "";
};

export const normalizeKSK1120_R01InspectionValue = (
	valueType: KSK1120_R01DetailDto["valueType"],
	value: unknown,
): string => {
	const normalizedValue = String(value ?? "").trim();
	if (!normalizedValue) return "";

	const normalizedValueType = normalizeKSK1120_R01ValueType(valueType);
	if (normalizedValueType === "PASS_FAIL") {
		const passFailValue = normalizedValue.toUpperCase();
		if (passFailValue === "Y" || passFailValue === "O") return "Y";
		if (passFailValue === "N" || passFailValue === "X") return "N";
		return "";
	}

	return normalizedValueType === "NUMERIC"
		? normalizedValue.replace(/,/g, "")
		: normalizedValue;
};

const createKSK1120_R01ApiInspectionValue = (
	valueType: KSK1120_R01DetailDto["valueType"],
	value: unknown,
): string => {
	const normalizedValue = normalizeKSK1120_R01InspectionValue(valueType, value);
	if (normalizeKSK1120_R01ValueType(valueType) !== "PASS_FAIL") return normalizedValue;
	return normalizedValue === "Y" ? "O" : normalizedValue === "N" ? "X" : "";
};

export const validateKSK1120_R01InspectionValue = (
	detail: KSK1120_R01DetailDto,
): boolean => KSK1120_R01_VALUE_FIELDS.every((field) => {
	const value = normalizeKSK1120_R01InspectionValue(detail.valueType, detail[field]);
	const valueType = normalizeKSK1120_R01ValueType(detail.valueType);
	if (!value) return true;
	if (valueType === "PASS_FAIL") return value === "Y" || value === "N";
	if (valueType === "NUMERIC") return /^-?(?:\d+\.?\d*|\.\d+)$/.test(value);
	return valueType === "TEXT" && value.length <= 100;
});

export const hasKSK1120_R01InspectionValue = (details: KSK1120_R01DetailDto[]): boolean =>
	details.some((detail) => KSK1120_R01_VALUE_FIELDS.some((field) =>
		normalizeKSK1120_R01InspectionValue(detail.valueType, detail[field]).length > 0,
	),
	);

export const normalizeKSK1120_R01InspectionDetail = (
	detail: KSK1120_R01DetailDto,
): KSK1120_R01DetailDto => ({
	...detail,
	valueType: normalizeKSK1120_R01ValueType(detail.valueType),
	...Object.fromEntries(KSK1120_R01_VALUE_FIELDS.map((field) => [
		field,
		normalizeKSK1120_R01InspectionValue(detail.valueType, detail[field]),
	])),
});

export const createKSK1120_R01SaveDetail = (
	detail: KSK1120_R01DetailDto,
	info: KSK1120_R01DetailDto,
): KSK1120_R01DetailDto => ({
	...detail,
	inspectNo: info.inspectNo,
	inspectDt: info.inspectDt,
	basOrderNo: info.basOrderNo,
	basOrderItemno: info.basOrderItemno,
	basLotNo: info.basLotNo,
	compCd: info.compCd,
	compNm: info.compNm,
	inspectType: info.inspectType,
	inspectTypeNm: info.inspectTypeNm,
	inspectorEmp: info.inspectorEmp,
	inspectorEmpNm: info.inspectorEmpNm,
	supplierCustom: info.supplierCustom,
	supplierCustomNm: info.supplierCustomNm,
	workplaceCd: info.workplaceCd,
	workplaceNm: info.workplaceNm,
	jobTeam: info.jobTeam,
	itemNm: info.itemNm,
	workerEmp: info.workerEmp,
	workerEmpNm: info.workerEmpNm,
	inspectQty: info.inspectQty,
	badQty: info.badQty,
	acceptQty: info.acceptQty,
	badCase: info.badCase,
	badCaseNm: info.badCaseNm,
	judgeEmpno: info.judgeEmpno,
	judgeEmpNm: info.judgeEmpNm,
	approvorEmpno: info.approvorEmpno,
	approvorEmpNm: info.approvorEmpNm,
	headerRemark: info.headerRemark,
	...Object.fromEntries(KSK1120_R01_VALUE_FIELDS.map((field) => [
		field,
		createKSK1120_R01ApiInspectionValue(detail.valueType, detail[field]),
	])),
});


